import { useLang } from "@/context/LanguageContext";

export default function LanguageToggle({ variant = "dark" }) {
  const { lang, setLang } = useLang();
  const baseColor = variant === "light" ? "text-[#FDFBF7]" : "text-[#1A1A1A]";
  const mutedColor = variant === "light" ? "text-[#FDFBF7]/40" : "text-[#1A1A1A]/30";
  return (
    <div
      className={`inline-flex items-center gap-3 text-[11px] font-semibold tracking-[0.25em] uppercase ${baseColor}`}
      data-testid="language-toggle"
    >
      <button
        onClick={() => setLang("pt")}
        className={lang === "pt" ? "" : mutedColor + " hover:opacity-80"}
        data-testid="lang-pt"
      >
        PT
      </button>
      <span className={mutedColor}>/</span>
      <button
        onClick={() => setLang("en")}
        className={lang === "en" ? "" : mutedColor + " hover:opacity-80"}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
